/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import { withUniqueRenderingId } from "~/hoc";
import Accordion from '../components/Accordion';
import AccordionTab from '../components/AccordionTab';
import AdBlock from '../components/AdBlock';
import AlertCard from '../components/AlertCard';
import AllStories from '../components/AllStories';
import BannerAd from '../components/BannerAd';
import Billing from '../components/Billing';
import Bio from '../components/Bio';
import BodyText from '../components/BodyText';
import BrightcoveFilmstrip from '../components/BrightcoveFilmstrip';
import BrightcoveVideo from '../components/BrightcoveVideo';
import BrightcoveVideoPlayer from '../components/BrightcoveVideoPlayer';
import CallToActionBanner from '../components/CallToActionBanner';
import CallToActionBlock from '../components/CallToActionBlock';
import CallToActionBlockWithIcon from '../components/CallToActionBlockWithIcon';
import CallToActionButton from '../components/CallToActionButton';
import Career from '../components/Career';
import CategoryPage from '../components/CategoryPage';
import CenteredFixedWidthLayout from '../components/CenteredFixedWidthLayout';
import CompetitionCard from '../components/CompetitionCard';
import CompetitionMatchList from '../components/CompetitionMatchList';
import CompetitionStandings from '../components/CompetitionStandings';
import Competitions from '../components/Competitions';
import CompetitionsGrid from '../components/CompetitionsGrid';
import ContactUs from '../components/ContactUs';
import Edition_EditionStoryGrid from '../components/Edition/EditionStoryGrid';
import Edition_EditionThumbnail from '../components/Edition/EditionThumbnail';
import EmailVerificationAlertCard from '../components/EmailVerificationAlertCard';
import Error404 from '../components/Error404';
import ExplicitGrid from '../components/ExplicitGrid';
import FeaturedContent from '../components/FeaturedContent';
import FeaturedStoriesGrid from '../components/FeaturedStoriesGrid';
import FiveInterestingThings from '../components/FiveInterestingThings';
import Footer from '../components/Footer';
import Forms_FormContactUs from '../components/Forms/FormContactUs';
import FourColumnLinks from '../components/FourColumnLinks';
import GalleryCarousel from '../components/GalleryCarousel';
import GigyaScreenSetAccordion from '../components/GigyaScreenSetAccordion';
import GigyaScreenSetHost from '../components/GigyaScreenSetHost';
import HeroHeader from '../components/HeroHeader';
import HorizontalNav from '../components/HorizontalNav';
import IconCard from '../components/IconCard';
import ImageBlock from '../components/ImageBlock';
import ImageWithTextCenter from '../components/ImageWithTextCenter';
import ImageWithTextLeft from '../components/ImageWithTextLeft';
import ImageWithTextRight from '../components/ImageWithTextRight';
import ImplicitGrid from '../components/ImplicitGrid';
import InfoBlock from '../components/InfoBlock';
import InstagramWidget from '../components/InstagramWidget';
import JsonLd from '../components/JsonLd';
import LatestStories from '../components/LatestStories';
import LatestVideos from '../components/LatestVideos';
import Layouts_AllCompetitionsTemplate from '../components/Layouts/AllCompetitionsTemplate';
import Layouts_AllMatchesTemplate from '../components/Layouts/AllMatchesTemplate';
import Layouts_AllPlayersTemplate from '../components/Layouts/AllPlayersTemplate';
import Layouts_AllTeamsTemplate from '../components/Layouts/AllTeamsTemplate';
import Layouts_CategoryPageTemplate from '../components/Layouts/CategoryPageTemplate';
import Layouts_EditionTemplate from '../components/Layouts/EditionTemplate';
import Layouts_EditionsTemplate from '../components/Layouts/EditionsTemplate';
import Layouts_GalleriesTemplate from '../components/Layouts/GalleriesTemplate';
import Layouts_GalleryTemplate from '../components/Layouts/GalleryTemplate';
import Layouts_HomeTemplate from '../components/Layouts/HomeTemplate';
import Layouts_LiveCompetitionTemplate from '../components/Layouts/LiveCompetitionTemplate';
import Layouts_LiveMatchTemplate from '../components/Layouts/LiveMatchTemplate';
import Layouts_PlayerTemplate from '../components/Layouts/PlayerTemplate';
import Layouts_PostCompetitionTemplate from '../components/Layouts/PostCompetitionTemplate';
import Layouts_PostMatchTemplate from '../components/Layouts/PostMatchTemplate';
import Layouts_PreCompetitionTemplate from '../components/Layouts/PreCompetitionTemplate';
import Layouts_PreMatchTemplate from '../components/Layouts/PreMatchTemplate';
import Layouts_StandardTemplate from '../components/Layouts/StandardTemplate';
import Layouts_StatsTemplate from '../components/Layouts/StatsTemplate';
import Layouts_StoriesTemplate from '../components/Layouts/StoriesTemplate';
import Layouts_StoryTemplate from '../components/Layouts/StoryTemplate';
import Layouts_TeamTemplate from '../components/Layouts/TeamTemplate';
import Layouts_TwoColumnsLayout from '../components/Layouts/TwoColumnsLayout';
import Lineups from '../components/Lineups';
import LineupsGrid from '../components/LineupsGrid';
import LinksBlock from '../components/LinksBlock';
import LoginGatedContent from '../components/LoginGatedContent';
import MatchPreview from '../components/MatchPreview';
import Matches_AllMatchesTabsWithFilter from '../components/Matches/AllMatchesTabsWithFilter';
import Matches_MatchModule from '../components/Matches/MatchModule';
import Matches_MatchScheduleCarousel from '../components/Matches/MatchScheduleCarousel';
import Matches_MatchesGridUpcoming from '../components/Matches/MatchesGridUpcoming';
import Matches_MatchesResultsGrid from '../components/Matches/MatchesResultsGrid';
import MediaCarousel from '../components/MediaCarousel';
import MediaThumbnail from '../components/MediaThumbnail';
import Membership_MembershipBanner from '../components/Membership/MembershipBanner';
import Membership_MembershipChart from '../components/Membership/MembershipChart';
import Membership_MembershipUpgradeCard from '../components/Membership/MembershipUpgradeCard';
import Membership_MyTickets from '../components/Membership/MyTickets';
import Membership_PerkCard from '../components/Membership/PerkCard';
import Membership_SmartMembershipCard from '../components/Membership/SmartMembershipCard';
import MembershipAccordionTab from '../components/MembershipAccordionTab';
import MembershipButtonGroup from '../components/MembershipButtonGroup';
import MembershipCard from '../components/MembershipCard';
import MembershipHero from '../components/MembershipHero';
import MembershipPerks from '../components/MembershipPerks';
import MoreStoriesGrid from '../components/MoreStoriesGrid';
import NavigationDesktop from '../components/NavigationDesktop';
import NavigationMobile from '../components/NavigationMobile';
import OrganizationsMembersAccordion from '../components/OrganizationsMembersAccordion';
import P1Announcement from '../components/P1Announcement';
import P1Competition from '../components/P1Competition';
import P1Image from '../components/P1Image';
import P1Match from '../components/P1Match';
import P1Membership from '../components/P1Membership';
import P1Player from '../components/P1Player';
import P1Story from '../components/P1Story';
import P1Team from '../components/P1Team';
import P1Text from '../components/P1Text';
import PlatformSwitch from '../components/PlatformSwitch';
import PlayerCarousel from '../components/PlayerCarousel';
import PlayerGrid from '../components/PlayerGrid';
import PlayerThumbnail from '../components/PlayerThumbnail';
import QABlock from '../components/QABlock';
import QuoteBlock from '../components/QuoteBlock';
import RedesignAngleImage from '../components/RedesignAngleImage';
import RedesignAngleImageAlternate from '../components/RedesignAngleImageAlternate';
import RedesignBrightCoveFilmStrip from '../components/RedesignBrightCoveFilmStrip';
import RedesignCarousel from '../components/RedesignCarousel';
import RedesignFeaturedMatch from '../components/RedesignFeaturedMatch';
import RedesignFeaturedStoriesGrid from '../components/RedesignFeaturedStoriesGrid';
import RedesignFiveThingsImage from '../components/RedesignFiveThingsImage';
import RedesignGoogleAd from '../components/RedesignGoogleAd';
import RedesignQuadBoxImage from '../components/RedesignQuadBoxImage';
import ScoreBarFeatured from '../components/ScoreBarFeatured';
import ScoreBarFull from '../components/ScoreBarFull';
import ScoreBarMini from '../components/ScoreBarMini';
import ScoreboardBanner from '../components/ScoreboardBanner';
import SearchResults from '../components/SearchResults';
import Section from '../components/Section';
import Sidebars_CategoriesSidebar from '../components/Sidebars/CategoriesSidebar';
import Sidebars_ProfileSidebarNav from '../components/Sidebars/ProfileSidebarNav';
import Sidebars_SidebarNav from '../components/Sidebars/SidebarNav';
import Sidebars_StatsSidebarNav from '../components/Sidebars/StatsSidebarNav';
import SplitPage from '../components/SplitPage';
import StadiumInfo from '../components/StadiumInfo';
import Stats_PlayerCareerStatistics from '../components/Stats/PlayerCareerStatistics';
import Stats_PlayerMatchStats from '../components/Stats/PlayerMatchStats';
import Stats_PlayerStats from '../components/Stats/PlayerStats';
import Stats_PlayerYearStats from '../components/Stats/PlayerYearStats';
import Stats_StatsOverview from '../components/Stats/StatsOverview';
import Stats_TeamStats from '../components/Stats/TeamStats';
import StoryGrid from '../components/StoryGrid';
import StoryThumbnail from '../components/StoryThumbnail';
import StyleGuide from '../components/StyleGuide';
import Table from '../components/Table';
import Tabs from '../components/Tabs';
import TabsTab from '../components/TabsTab';
import TagsBlock from '../components/TagsBlock';
import TeamGrid from '../components/TeamGrid';
import TextBlock from '../components/TextBlock';
import TextBlockWithAd300x250 from '../components/TextBlockWithAd300x250';
import TextBlockWithAd300x600 from '../components/TextBlockWithAd300x600';
import TextLink from '../components/TextLink';
import TicketOptions from '../components/TicketOptions';
import TicketTextBlock from '../components/TicketTextBlock';
import TitledSection from '../components/TitledSection';
import Trophies from '../components/Trophies';
import TweetWidget from '../components/TweetWidget';
import TwoColumnsGrid from '../components/TwoColumnsGrid';
import UserPresaleCodes from '../components/UserPresaleCodes';
import VideoList from '../components/VideoList';
import VideoPlayer from '../components/VideoPlayer';
import WatchHub from '../components/WatchHub';

const components = new Map();
components.set('Accordion', withUniqueRenderingId()(Accordion));
components.set('AccordionTab', withUniqueRenderingId()(AccordionTab));
components.set('AdBlock', withUniqueRenderingId()(AdBlock));
components.set('AlertCard', withUniqueRenderingId()(AlertCard));
components.set('AllStories', withUniqueRenderingId()(AllStories));
components.set('BannerAd', withUniqueRenderingId()(BannerAd));
components.set('Billing', withUniqueRenderingId()(Billing));
components.set('Bio', withUniqueRenderingId()(Bio));
components.set('BodyText', withUniqueRenderingId()(BodyText));
components.set('BrightcoveFilmstrip', withUniqueRenderingId()(BrightcoveFilmstrip));
components.set('BrightcoveVideo', withUniqueRenderingId()(BrightcoveVideo));
components.set('BrightcoveVideoPlayer', withUniqueRenderingId()(BrightcoveVideoPlayer));
components.set('CallToActionBanner', withUniqueRenderingId()(CallToActionBanner));
components.set('CallToActionBlock', withUniqueRenderingId()(CallToActionBlock));
components.set('CallToActionBlockWithIcon', withUniqueRenderingId()(CallToActionBlockWithIcon));
components.set('CallToActionButton', withUniqueRenderingId()(CallToActionButton));
components.set('Career', withUniqueRenderingId()(Career));
components.set('CategoryPage', withUniqueRenderingId()(CategoryPage));
components.set('CenteredFixedWidthLayout', withUniqueRenderingId()(CenteredFixedWidthLayout));
components.set('CompetitionCard', withUniqueRenderingId()(CompetitionCard));
components.set('CompetitionMatchList', withUniqueRenderingId()(CompetitionMatchList));
components.set('CompetitionStandings', withUniqueRenderingId()(CompetitionStandings));
components.set('Competitions', withUniqueRenderingId()(Competitions));
components.set('CompetitionsGrid', withUniqueRenderingId()(CompetitionsGrid));
components.set('ContactUs', withUniqueRenderingId()(ContactUs));
components.set('Edition_EditionStoryGrid', withUniqueRenderingId()(Edition_EditionStoryGrid));
components.set('Edition_EditionThumbnail', withUniqueRenderingId()(Edition_EditionThumbnail));
components.set('EmailVerificationAlertCard', withUniqueRenderingId()(EmailVerificationAlertCard));
components.set('Error404', withUniqueRenderingId()(Error404));
components.set('ExplicitGrid', withUniqueRenderingId()(ExplicitGrid));
components.set('FeaturedContent', withUniqueRenderingId()(FeaturedContent));
components.set('FeaturedStoriesGrid', withUniqueRenderingId()(FeaturedStoriesGrid));
components.set('FiveInterestingThings', withUniqueRenderingId()(FiveInterestingThings));
components.set('Footer', withUniqueRenderingId()(Footer));
components.set('Forms_FormContactUs', withUniqueRenderingId()(Forms_FormContactUs));
components.set('FourColumnLinks', withUniqueRenderingId()(FourColumnLinks));
components.set('GalleryCarousel', withUniqueRenderingId()(GalleryCarousel));
components.set('GigyaScreenSetAccordion', withUniqueRenderingId()(GigyaScreenSetAccordion));
components.set('GigyaScreenSetHost', withUniqueRenderingId()(GigyaScreenSetHost));
components.set('HeroHeader', withUniqueRenderingId()(HeroHeader));
components.set('HorizontalNav', withUniqueRenderingId()(HorizontalNav));
components.set('IconCard', withUniqueRenderingId()(IconCard));
components.set('ImageBlock', withUniqueRenderingId()(ImageBlock));
components.set('ImageWithTextCenter', withUniqueRenderingId()(ImageWithTextCenter));
components.set('ImageWithTextLeft', withUniqueRenderingId()(ImageWithTextLeft));
components.set('ImageWithTextRight', withUniqueRenderingId()(ImageWithTextRight));
components.set('ImplicitGrid', withUniqueRenderingId()(ImplicitGrid));
components.set('InfoBlock', withUniqueRenderingId()(InfoBlock));
components.set('InstagramWidget', withUniqueRenderingId()(InstagramWidget));
components.set('JsonLd', withUniqueRenderingId()(JsonLd));
components.set('LatestStories', withUniqueRenderingId()(LatestStories));
components.set('LatestVideos', withUniqueRenderingId()(LatestVideos));
components.set('Layouts_AllCompetitionsTemplate', withUniqueRenderingId()(Layouts_AllCompetitionsTemplate));
components.set('Layouts_AllMatchesTemplate', withUniqueRenderingId()(Layouts_AllMatchesTemplate));
components.set('Layouts_AllPlayersTemplate', withUniqueRenderingId()(Layouts_AllPlayersTemplate));
components.set('Layouts_AllTeamsTemplate', withUniqueRenderingId()(Layouts_AllTeamsTemplate));
components.set('Layouts_CategoryPageTemplate', withUniqueRenderingId()(Layouts_CategoryPageTemplate));
components.set('Layouts_EditionTemplate', withUniqueRenderingId()(Layouts_EditionTemplate));
components.set('Layouts_EditionsTemplate', withUniqueRenderingId()(Layouts_EditionsTemplate));
components.set('Layouts_GalleriesTemplate', withUniqueRenderingId()(Layouts_GalleriesTemplate));
components.set('Layouts_GalleryTemplate', withUniqueRenderingId()(Layouts_GalleryTemplate));
components.set('Layouts_HomeTemplate', withUniqueRenderingId()(Layouts_HomeTemplate));
components.set('Layouts_LiveCompetitionTemplate', withUniqueRenderingId()(Layouts_LiveCompetitionTemplate));
components.set('Layouts_LiveMatchTemplate', withUniqueRenderingId()(Layouts_LiveMatchTemplate));
components.set('Layouts_PlayerTemplate', withUniqueRenderingId()(Layouts_PlayerTemplate));
components.set('Layouts_PostCompetitionTemplate', withUniqueRenderingId()(Layouts_PostCompetitionTemplate));
components.set('Layouts_PostMatchTemplate', withUniqueRenderingId()(Layouts_PostMatchTemplate));
components.set('Layouts_PreCompetitionTemplate', withUniqueRenderingId()(Layouts_PreCompetitionTemplate));
components.set('Layouts_PreMatchTemplate', withUniqueRenderingId()(Layouts_PreMatchTemplate));
components.set('Layouts_StandardTemplate', withUniqueRenderingId()(Layouts_StandardTemplate));
components.set('Layouts_StatsTemplate', withUniqueRenderingId()(Layouts_StatsTemplate));
components.set('Layouts_StoriesTemplate', withUniqueRenderingId()(Layouts_StoriesTemplate));
components.set('Layouts_StoryTemplate', withUniqueRenderingId()(Layouts_StoryTemplate));
components.set('Layouts_TeamTemplate', withUniqueRenderingId()(Layouts_TeamTemplate));
components.set('Layouts_TwoColumnsLayout', withUniqueRenderingId()(Layouts_TwoColumnsLayout));
components.set('Lineups', withUniqueRenderingId()(Lineups));
components.set('LineupsGrid', withUniqueRenderingId()(LineupsGrid));
components.set('LinksBlock', withUniqueRenderingId()(LinksBlock));
components.set('LoginGatedContent', withUniqueRenderingId()(LoginGatedContent));
components.set('MatchPreview', withUniqueRenderingId()(MatchPreview));
components.set('Matches_AllMatchesTabsWithFilter', withUniqueRenderingId()(Matches_AllMatchesTabsWithFilter));
components.set('Matches_MatchModule', withUniqueRenderingId()(Matches_MatchModule));
components.set('Matches_MatchScheduleCarousel', withUniqueRenderingId()(Matches_MatchScheduleCarousel));
components.set('Matches_MatchesGridUpcoming', withUniqueRenderingId()(Matches_MatchesGridUpcoming));
components.set('Matches_MatchesResultsGrid', withUniqueRenderingId()(Matches_MatchesResultsGrid));
components.set('MediaCarousel', withUniqueRenderingId()(MediaCarousel));
components.set('MediaThumbnail', withUniqueRenderingId()(MediaThumbnail));
components.set('Membership_MembershipBanner', withUniqueRenderingId()(Membership_MembershipBanner));
components.set('Membership_MembershipChart', withUniqueRenderingId()(Membership_MembershipChart));
components.set('Membership_MembershipUpgradeCard', withUniqueRenderingId()(Membership_MembershipUpgradeCard));
components.set('Membership_MyTickets', withUniqueRenderingId()(Membership_MyTickets));
components.set('Membership_PerkCard', withUniqueRenderingId()(Membership_PerkCard));
components.set('Membership_SmartMembershipCard', withUniqueRenderingId()(Membership_SmartMembershipCard));
components.set('MembershipAccordionTab', withUniqueRenderingId()(MembershipAccordionTab));
components.set('MembershipButtonGroup', withUniqueRenderingId()(MembershipButtonGroup));
components.set('MembershipCard', withUniqueRenderingId()(MembershipCard));
components.set('MembershipHero', withUniqueRenderingId()(MembershipHero));
components.set('MembershipPerks', withUniqueRenderingId()(MembershipPerks));
components.set('MoreStoriesGrid', withUniqueRenderingId()(MoreStoriesGrid));
components.set('NavigationDesktop', withUniqueRenderingId()(NavigationDesktop));
components.set('NavigationMobile', withUniqueRenderingId()(NavigationMobile));
components.set('OrganizationsMembersAccordion', withUniqueRenderingId()(OrganizationsMembersAccordion));
components.set('P1Announcement', withUniqueRenderingId()(P1Announcement));
components.set('P1Competition', withUniqueRenderingId()(P1Competition));
components.set('P1Image', withUniqueRenderingId()(P1Image));
components.set('P1Match', withUniqueRenderingId()(P1Match));
components.set('P1Membership', withUniqueRenderingId()(P1Membership));
components.set('P1Player', withUniqueRenderingId()(P1Player));
components.set('P1Story', withUniqueRenderingId()(P1Story));
components.set('P1Team', withUniqueRenderingId()(P1Team));
components.set('P1Text', withUniqueRenderingId()(P1Text));
components.set('PlatformSwitch', withUniqueRenderingId()(PlatformSwitch));
components.set('PlayerCarousel', withUniqueRenderingId()(PlayerCarousel));
components.set('PlayerGrid', withUniqueRenderingId()(PlayerGrid));
components.set('PlayerThumbnail', withUniqueRenderingId()(PlayerThumbnail));
components.set('QABlock', withUniqueRenderingId()(QABlock));
components.set('QuoteBlock', withUniqueRenderingId()(QuoteBlock));
components.set('RedesignAngleImage', withUniqueRenderingId()(RedesignAngleImage));
components.set('RedesignAngleImageAlternate', withUniqueRenderingId()(RedesignAngleImageAlternate));
components.set('RedesignBrightCoveFilmStrip', withUniqueRenderingId()(RedesignBrightCoveFilmStrip));
components.set('RedesignCarousel', withUniqueRenderingId()(RedesignCarousel));
components.set('RedesignFeaturedMatch', withUniqueRenderingId()(RedesignFeaturedMatch));
components.set('RedesignFeaturedStoriesGrid', withUniqueRenderingId()(RedesignFeaturedStoriesGrid));
components.set('RedesignFiveThingsImage', withUniqueRenderingId()(RedesignFiveThingsImage));
components.set('RedesignGoogleAd', withUniqueRenderingId()(RedesignGoogleAd));
components.set('RedesignQuadBoxImage', withUniqueRenderingId()(RedesignQuadBoxImage));
components.set('ScoreBarFeatured', withUniqueRenderingId()(ScoreBarFeatured));
components.set('ScoreBarFull', withUniqueRenderingId()(ScoreBarFull));
components.set('ScoreBarMini', withUniqueRenderingId()(ScoreBarMini));
components.set('ScoreboardBanner', withUniqueRenderingId()(ScoreboardBanner));
components.set('SearchResults', withUniqueRenderingId()(SearchResults));
components.set('Section', withUniqueRenderingId()(Section));
components.set('Sidebars_CategoriesSidebar', withUniqueRenderingId()(Sidebars_CategoriesSidebar));
components.set('Sidebars_ProfileSidebarNav', withUniqueRenderingId()(Sidebars_ProfileSidebarNav));
components.set('Sidebars_SidebarNav', withUniqueRenderingId()(Sidebars_SidebarNav));
components.set('Sidebars_StatsSidebarNav', withUniqueRenderingId()(Sidebars_StatsSidebarNav));
components.set('SplitPage', withUniqueRenderingId()(SplitPage));
components.set('StadiumInfo', withUniqueRenderingId()(StadiumInfo));
components.set('Stats_PlayerCareerStatistics', withUniqueRenderingId()(Stats_PlayerCareerStatistics));
components.set('Stats_PlayerMatchStats', withUniqueRenderingId()(Stats_PlayerMatchStats));
components.set('Stats_PlayerStats', withUniqueRenderingId()(Stats_PlayerStats));
components.set('Stats_PlayerYearStats', withUniqueRenderingId()(Stats_PlayerYearStats));
components.set('Stats_StatsOverview', withUniqueRenderingId()(Stats_StatsOverview));
components.set('Stats_TeamStats', withUniqueRenderingId()(Stats_TeamStats));
components.set('StoryGrid', withUniqueRenderingId()(StoryGrid));
components.set('StoryThumbnail', withUniqueRenderingId()(StoryThumbnail));
components.set('StyleGuide', withUniqueRenderingId()(StyleGuide));
components.set('Table', withUniqueRenderingId()(Table));
components.set('Tabs', withUniqueRenderingId()(Tabs));
components.set('TabsTab', withUniqueRenderingId()(TabsTab));
components.set('TagsBlock', withUniqueRenderingId()(TagsBlock));
components.set('TeamGrid', withUniqueRenderingId()(TeamGrid));
components.set('TextBlock', withUniqueRenderingId()(TextBlock));
components.set('TextBlockWithAd300x250', withUniqueRenderingId()(TextBlockWithAd300x250));
components.set('TextBlockWithAd300x600', withUniqueRenderingId()(TextBlockWithAd300x600));
components.set('TextLink', withUniqueRenderingId()(TextLink));
components.set('TicketOptions', withUniqueRenderingId()(TicketOptions));
components.set('TicketTextBlock', withUniqueRenderingId()(TicketTextBlock));
components.set('TitledSection', withUniqueRenderingId()(TitledSection));
components.set('Trophies', withUniqueRenderingId()(Trophies));
components.set('TweetWidget', withUniqueRenderingId()(TweetWidget));
components.set('TwoColumnsGrid', withUniqueRenderingId()(TwoColumnsGrid));
components.set('UserPresaleCodes', withUniqueRenderingId()(UserPresaleCodes));
components.set('VideoList', withUniqueRenderingId()(VideoList));
components.set('VideoPlayer', withUniqueRenderingId()(VideoPlayer));
components.set('WatchHub', withUniqueRenderingId()(WatchHub));

export default function componentFactory(componentName) {
  return components.get(componentName);
};